<div [attr.disabled]="disabled ? true : undefined"></div>
